import { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { Logo } from "@/components/Logo";
import { CheckCircle2, Loader2, XCircle } from "lucide-react";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const [status, setStatus] = useState("checking");
  const [plan, setPlan] = useState("");

  useEffect(() => {
    const sid = params.get("session_id");
    if (!sid) { setStatus("error"); return; }
    let attempts = 0;
    const poll = async () => {
      attempts += 1;
      try {
        const { data } = await api.get(`/payments/status/${sid}`);
        setPlan(data.plan);
        if (data.payment_status === "paid") { setStatus("paid"); return; }
        if (["failed", "expired"].includes(data.payment_status)) { setStatus("failed"); return; }
      } catch { /* keep polling */ }
      if (attempts < 12) setTimeout(poll, 2000); else setStatus("timeout");
    };
    poll();
  }, [params]);

  return (
    <div className="min-h-screen grid place-items-center p-6">
      <div className="w-full max-w-md rounded-2xl border border-white/10 bg-surface p-10 text-center">
        <div className="flex justify-center mb-6"><Logo /></div>
        {status === "checking" && (<><Loader2 className="mx-auto text-azure animate-spin" size={40} /><p className="mt-5 text-muted">Confirming your payment…</p></>)}
        {status === "paid" && (<>
          <CheckCircle2 className="mx-auto text-emerald" size={48} />
          <h1 className="mt-5 font-display font-bold text-2xl">Access activated</h1>
          <p className="mt-2 text-muted text-sm">Your {plan} access is now active. Full platform features are unlocked.</p>
          <button onClick={() => nav("/employer")} data-testid="payment-continue" className="mt-7 rounded-full bg-azure px-6 py-3 text-sm font-medium text-white hover:bg-white hover:text-black transition-colors duration-200">Go to workspace</button>
        </>)}
        {(status === "failed" || status === "error") && (<>
          <XCircle className="mx-auto text-signal" size={48} />
          <h1 className="mt-5 font-display font-bold text-2xl">Payment not completed</h1>
          <p className="mt-2 text-muted text-sm">No access was activated. You can try again from your workspace.</p>
          <button onClick={() => nav("/employer")} className="mt-7 rounded-full border border-white/15 px-6 py-3 text-sm text-ink hover:bg-white hover:text-black transition-colors duration-200">Back to workspace</button>
        </>)}
        {status === "timeout" && (<>
          <Loader2 className="mx-auto text-amber" size={40} />
          <p className="mt-5 text-muted text-sm">Still processing. Your access will activate shortly — check your workspace.</p>
          <button onClick={() => nav("/employer")} className="mt-6 rounded-full border border-white/15 px-6 py-3 text-sm text-ink">Go to workspace</button>
        </>)}
      </div>
    </div>
  );
}
